import type { subscription as en } from '@/i18n/locales/en/subscription';
import type { Translation } from '@/i18n/types';

export const subscription: Translation<typeof en> = {
  title: 'Συνδρομή',
  lead: 'Διαχειριστείτε τη δική σας συνδρομή — πλάνο, πληρωμή και ακύρωση.',
  dialogCancel: 'Ακύρωση',
  status: {
    title: 'Κατάσταση',
    active: 'Ενεργή',
    inactive: 'Ανενεργή',
    tier: 'Πλάνο',
    expires: 'Λήγει',
    autoRenews: 'Ανανεώνεται αυτόματα',
    doesNotRenew: 'Δεν ανανεώνεται',
    nextCharge: 'Επόμενη χρέωση',
    blocked: 'Δεν μπορείτε να ξεκινήσετε συνδρομή μέσω web αυτή τη στιγμή.',
  },
  plans: {
    title: 'Πλάνα',
    monthly: 'Μηνιαία',
    yearly: 'Ετήσια',
    perMonth: '{{price}} / μήνα',
    perYear: '{{price}} / έτος',
    subscribe: 'Εγγραφή',
    current: 'Τρέχον πλάνο',
    switchToYearly: 'Αλλαγή σε ετήσιο',
    switchToMonthly: 'Αλλαγή σε μηνιαίο',
    switchWarning:
      'Η αλλαγή ακυρώνει την τρέχουσα συνδρομή σας και ξεκινά τη νέα αμέσως με την ίδια εντολή πληρωμής. Η επικάλυψη μεταξύ των δύο περιόδων δεν επιστρέφεται — ενδέχεται να χρεωθείτε δύο φορές για αυτήν.',
    switchConfirm: 'Ναι, αλλαγή πλάνου',
    blocked: 'Έχετε ήδη ενεργή συνδρομή, οπότε δεν μπορεί να ξεκινήσει άλλο πλάνο αυτή τη στιγμή.',
  },
  manage: {
    title: 'Διαχείριση',
    cancel: 'Ακύρωση συνδρομής',
    cancelConfirm: 'Ναι, ακύρωση',
    cancelled: 'Ακυρώθηκε — η πρόσβαση παραμένει μέχρι {{date}}.',
    proRataNote:
      'Στο ετήσιο πλάνο, η ακύρωση μετά την πρώτη περίοδο πληρωμής επιστρέφει τους ολόκληρους μήνες που δεν χρησιμοποιήθηκαν και τερματίζει την πρόσβαση αμέσως αντί στο τέλος της περιόδου.',
    withdraw: 'Υπαναχώρηση (εντός 14 ημερών)',
    withdrawHint: 'Διαθέσιμη για 14 ημέρες μετά την πρώτη σας πληρωμή, μία φορά, ανά συνδρομή.',
  },
  history: {
    title: 'Ιστορικό',
    empty: 'Δεν υπάρχουν ακόμη αγορές.',
    date: 'Ημερομηνία',
    period: 'Περίοδος',
    channel: 'Κανάλι',
    state: 'Κατάσταση',
    state_granted: 'Χορηγήθηκε',
    state_refunded: 'Επιστράφηκε',
    state_revoked: 'Ανακλήθηκε',
    state_charged_back: 'Αντιλογισμός',
    state_rejected: 'Απορρίφθηκε',
    invoice: 'Τιμολόγιο',
    withdrawLink: 'Υπαναχώρηση',
    manageLink: 'Διαχείριση στο κατάστημα',
  },
  checkout: {
    title: 'Ολοκλήρωση αγοράς',
    lead: 'Ελέγξτε το πλάνο σας πριν συνεχίσετε στο Mollie.',
    plan: 'Πλάνο',
    price: 'Τιμή',
    consentLabel:
      'Θέλω η υπηρεσία να ξεκινήσει αμέσως και κατανοώ ότι, αν υπαναχωρήσω, θα πληρώσω αναλογικά για το μέρος που έχω ήδη χρησιμοποιήσει.',
    start: 'Συνέχεια στο Mollie',
    errorAlreadySubscribed: 'Έχετε ήδη ενεργή συνδρομή.',
    errorProductUnavailable: 'Αυτό το πλάνο δεν είναι διαθέσιμο αυτή τη στιγμή.',
  },
  return: {
    title: 'Κατάσταση πληρωμής',
    waiting: 'Περιμένουμε ακόμη την επιβεβαίωση της πληρωμής.',
    success: 'Η πληρωμή ελήφθη — η συνδρομή σας είναι ενεργή.',
    backToSubscription: 'Επιστροφή στη συνδρομή σας',
  },
  withdraw: {
    title: 'Υπαναχώρηση από τη συνδρομή σας',
    lead: 'Η υπαναχώρηση εντός της προθεσμίας 14 ημερών τερματίζει την πρόσβασή σας αμέσως — σε αντίθεση με την ακύρωση, η οποία ισχύει μέχρι το τέλος της περιόδου που έχετε ήδη πληρώσει.',
    refundTypeFull: 'Θα λάβετε πλήρη επιστροφή χρημάτων.',
    refundTypeProRata:
      'Θα λάβετε αναλογική επιστροφή χρημάτων για το μέρος που δεν έχει χρησιμοποιηθεί ακόμη.',
    refundAmount: 'Ποσό επιστροφής',
    deadline: 'Προθεσμία',
    confirm: 'Υπαναχώρηση και τερματισμός πρόσβασης τώρα',
    confirmed: 'Έγινε υπαναχώρηση — θα επιστραφούν {{amount}}.',
    errorWindowExpired: 'Η προθεσμία υπαναχώρησης 14 ημερών έχει παρέλθει.',
    errorAlreadyWithdrawn: 'Έχετε ήδη υπαναχωρήσει από αυτή τη συνδρομή.',
  },
};
